import React, { useContext } from 'react';
import RuleName from './rule-name';
import RuleTypeSelector from './rule-type-selector';
import RuleActions from './rule-actions';
import NewActionButton from './new-action-button';
import FormErrorDisplay from './form-error-display';
import { AutomationRulesContext } from '../../context';

const EditorBody = () => {
  const { formErrorOccurred } = useContext(AutomationRulesContext);
  return (
    <React.Fragment>
      {formErrorOccurred && <FormErrorDisplay />}
      <RuleName />
      <RuleTypeSelector />
      <RuleActions />
      <NewActionButton />
    </React.Fragment>
  );
};

export default EditorBody;
